export default "__VITE_ASSET__b1f9a295__"